// ALL BANNER
export const GET_BANNER_REQUEST = "GET_BANNER_REQUEST";
export const GET_BANNER_SUCCESS = "GET_BANNER_SUCCESS";
export const GET_BANNER_FAILURE = "GET_BANNER_FAILURE";

// Get CATEGORY
export const GET_CATEGORY_REQUEST = "GET_CATEGORY_REQUEST";
export const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS";
export const GET_CATEGORY_FAILURE = "GET_CATEGORY_FAILURE";

// Get SUBCATEGORY
export const GET_SUBCATEGORY_REQUEST = "GET_SUBCATEGORY_REQUEST";
export const GET_SUBCATEGORY_SUCCESS = "GET_SUBCATEGORY_SUCCESS";
export const GET_SUBCATEGORY_FAILURE = "GET_SUBCATEGORY_FAILURE";

// Get PRODUCTLIST
export const GET_PRODUCTLIST_REQUEST = "GET_PRODUCTLIST_REQUEST";
export const GET_PRODUCTLIST_SUCCESS = "GET_PRODUCTLIST_SUCCESS";
export const GET_PRODUCTLIST_FAILURE = "GET_PRODUCTLIST_FAILURE";

// Get PRODUCT Details
export const GET_PRODUCT_DETAILS_REQUEST = "GET_PRODUCT_DETAILS_REQUEST";
export const GET_PRODUCT_DETAILS_SUCCESS = "GET_PRODUCT_DETAILS_SUCCESS";
export const GET_PRODUCT_DETAILS_FAILURE = "GET_PRODUCT_DETAILS_FAILURE";

// Get PRODUCT CATEGORY 
export const GET_PRODUCT_CATEGORY_REQUEST = "GET_PRODUCT_CATEGORY_REQUEST";
export const GET_PRODUCT_CATEGORY_SUCCESS = "GET_PRODUCT_CATEGORY_SUCCESS";
export const GET_PRODUCT_CATEGORY_FAILURE = "GET_PRODUCT_CATEGORY_FAILURE";

// Get PRODUCT Enquiries 
export const GET_ENQUIRIES_FORM_REQUEST = "GET_ENQUIRIES_FORM_REQUEST";
export const GET_ENQUIRIES_FORM_SUCCESS = "GET_ENQUIRIES_FORM_SUCCESS";
export const GET_ENQUIRIES_FORM_FAILURE = "GET_ENQUIRIES_FORM_FAILURE";

// Get Career form data 
export const GET_CAREER_FORM_REQUEST = "GET_CAREER_FORM_REQUEST";
export const GET_CAREER_FORM_SUCCESS = "GET_CAREER_FORM_SUCCESS";
export const GET_CAREER_FORM_FAILURE = "GET_CAREER_FORM_FAILURE";

// Get rating data 
export const GET_RATING_FORM_REQUEST = "GET_RATING_FORM_REQUEST";
export const GET_RATING_FORM_SUCCESS = "GET_RATING_FORM_SUCCESS";
export const GET_RATING_FORM_FAILURE = "GET_RATING_FORM_FAILURE";

// Get commnet data list  
export const GET_COMMENT_DATA_LIST_REQUEST = "GET_COMMENT_DATA_LIST_REQUEST";
export const GET_COMMENT_DATA_LIST_SUCCESS = "GET_COMMENT_DATA_LIST_SUCCESS";
export const GET_COMMENT_DATA_LIST_FAILURE = "GET_COMMENT_DATA_LIST_FAILURE";

// Get Contact Form 
export const GET_CONTACT_FORM_REQUEST = "GET_CONTACT_FORM_REQUEST";
export const GET_CONTACT_FORM_SUCCESS = "GET_CONTACT_FORM_SUCCESS";
export const GET_CONTACT_FORM_FAILURE = "GET_CONTACT_FORM_FAILURE";

// Get SUb category Product 
export const GET_SUB_CATEGORY_PRODUCT_REQUEST = "GET_SUB_CATEGORY_PRODUCT_REQUEST";
export const GET_SUB_CATEGORY_PRODUCT_SUCCESS = "GET_SUB_CATEGORY_PRODUCT_SUCCESS";
export const GET_SUB_CATEGORY_PRODUCT_FAILURE = "GET_SUB_CATEGORY_PRODUCT_FAILURE";